import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createTextVNode as _createTextVNode, vModelText as _vModelText, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "marketing-publication-panel",
  "data-testid": "marketing-publication-panel"
}
const _hoisted_2 = {
  key: 0,
  class: "marketing-article-error",
  role: "alert"
}
const _hoisted_3 = {
  key: 1,
  class: "marketing-quality-migration",
  "data-testid": "marketing-quality-migration"
}
const _hoisted_4 = {
  key: 2,
  class: "marketing-publication-success",
  "data-testid": "marketing-publication-success"
}
const _hoisted_5 = { class: "marketing-article-detail-list" }
const _hoisted_6 = {
  key: 0,
  class: "marketing-article-warning-list"
}
const _hoisted_7 = {
  class: "marketing-publication-outcomes",
  "data-testid": "marketing-publication-outcomes"
}
const _hoisted_8 = { class: "marketing-publication-heading" }
const _hoisted_9 = ["disabled"]
const _hoisted_10 = {
  key: 0,
  class: "marketing-publication-category-grid"
}
const _hoisted_11 = { key: 0 }
const _hoisted_12 = {
  key: 1,
  class: "marketing-outcome-decision",
  "data-testid": "marketing-outcome-decision"
}
const _hoisted_13 = {
  key: 2,
  class: "marketing-publication-measurements"
}
const _hoisted_14 = { class: "marketing-search-observation-grid" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 3,
  class: "marketing-search-observation-history"
}
const _hoisted_17 = { class: "marketing-article-completion-actions" }
const _hoisted_18 = ["href"]
const _hoisted_19 = ["href"]
const _hoisted_20 = ["disabled"]
const _hoisted_21 = { class: "marketing-publication-heading" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "marketing-article-detail-list marketing-publication-summary" }
const _hoisted_26 = { class: "marketing-publication-automation" }
const _hoisted_27 = {
  key: 0,
  class: "marketing-article-result-section warning",
  "data-testid": "marketing-publication-conflicts"
}
const _hoisted_28 = { class: "marketing-article-completion-actions" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "marketing-publication-checks" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 1,
  class: "marketing-publication-confirmation",
  "data-testid": "marketing-publication-confirmation"
}
const _hoisted_33 = {
  key: 0,
  class: "marketing-publication-deferred-note",
  "data-testid": "marketing-publication-deferred-note"
}
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  key: 2,
  class: "marketing-publication-note"
}
const _hoisted_38 = {
  key: 3,
  class: "marketing-publication-note"
}
const _hoisted_39 = {
  key: 4,
  class: "marketing-publication-start"
}
const _hoisted_40 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (_ctx.errorMessage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.errorMessage), 1))
      : _createCommentVNode("", true),
    (_ctx.migrationRequired)
      ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
          _cache[27] || (_cache[27] = _createElementVNode("h4", null, "旧記事の品質計画を移行してください", -1)),
          _cache[28] || (_cache[28] = _createElementVNode("p", null, "新規公開・再公開・大幅更新にはeditorial_quality_plan-v1が必要です。計画を再作成できない場合に限り、人が理由を記録して移行を明示承認できます。", -1)),
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.migrationConfirmed) = $event)),
              type: "checkbox"
            }, null, 512), [
              [_vModelCheckbox, _ctx.migrationConfirmed]
            ]),
            _cache[25] || (_cache[25] = _createTextVNode(" この旧記事を理由付きで明示的に移行承認する ", -1))
          ]),
          _createElementVNode("label", null, [
            _cache[26] || (_cache[26] = _createTextVNode(" 承認理由 ", -1)),
            _withDirectives(_createElementVNode("textarea", {
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.migrationReason) = $event)),
              maxlength: "1000",
              placeholder: "計画を再作成せず移行する理由と、人が確認した範囲を記録してください。"
            }, null, 512), [
              [
                _vModelText,
                _ctx.migrationReason,
                void 0,
                { trim: true }
              ]
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.article.publication_status == 'published')
      ? (_openBlock(), _createElementBlock("section", _hoisted_4, [
          _cache[65] || (_cache[65] = _createElementVNode("h3", null, "WordPress上に記事を公開しました", -1)),
          _createElementVNode("dl", _hoisted_5, [
            _cache[29] || (_cache[29] = _createElementVNode("dt", null, "記事タイトル", -1)),
            _createElementVNode("dd", null, _toDisplayString(_ctx.article.sanitized_content?.title || "-"), 1),
            _cache[30] || (_cache[30] = _createElementVNode("dt", null, "公開URL", -1)),
            _createElementVNode("dd", null, _toDisplayString(_ctx.article.wordpress_published_url || "安全なURLを確認できません"), 1),
            _cache[31] || (_cache[31] = _createElementVNode("dt", null, "WordPress投稿ID", -1)),
            _createElementVNode("dd", null, _toDisplayString(_ctx.article.wordpress_post_id), 1),
            _cache[32] || (_cache[32] = _createElementVNode("dt", null, "公開日時", -1)),
            _createElementVNode("dd", null, _toDisplayString(_ctx.article.wordpress_published_date || _ctx.article.published_at || "-"), 1),
            _cache[33] || (_cache[33] = _createElementVNode("dt", null, "SEOタイトル", -1)),
            _createElementVNode("dd", null, _toDisplayString(_ctx.article.seo_title || "-"), 1),
            _cache[34] || (_cache[34] = _createElementVNode("dt", null, "メタディスクリプション", -1)),
            _createElementVNode("dd", null, _toDisplayString(_ctx.article.meta_description || "-"), 1),
            _cache[35] || (_cache[35] = _createElementVNode("dt", null, "canonical", -1)),
            _createElementVNode("dd", null, _toDisplayString(_ctx.article.seo_audit_result?.page?.canonical || _ctx.article.canonical_policy || "確認中"), 1),
            _cache[36] || (_cache[36] = _createElementVNode("dt", null, "robots状態", -1)),
            _createElementVNode("dd", null, _toDisplayString(_ctx.article.seo_audit_result?.page?.robots || _ctx.article.index_policy || "確認中"), 1),
            _cache[37] || (_cache[37] = _createElementVNode("dt", null, "構造化データ状態", -1)),
            _createElementVNode("dd", null, _toDisplayString(_ctx.article.seo_audit_result?.page?.article_schema_type?.join?.("、") || _ctx.article.seo_audit_status), 1),
            _cache[38] || (_cache[38] = _createElementVNode("dt", null, "サイトマップ状態", -1)),
            _createElementVNode("dd", null, _toDisplayString(_ctx.article.seo_audit_result?.sitemap?.status || "確認中") + " / Search Console: " + _toDisplayString(_ctx.article.sitemap_submission_status || "未確認"), 1),
            _cache[39] || (_cache[39] = _createElementVNode("dt", null, "Search Console状態", -1)),
            _createElementVNode("dd", null, _toDisplayString(_ctx.article.url_inspection_status || "未確認"), 1),
            _cache[40] || (_cache[40] = _createElementVNode("dt", null, "SEO監査結果", -1)),
            _createElementVNode("dd", null, _toDisplayString(_ctx.auditStatusLabel), 1)
          ]),
          _cache[66] || (_cache[66] = _createElementVNode("p", { class: "marketing-publication-note" }, "サイトマップ送信やURL Inspectionの確認は、クロールやインデックス登録を保証しません。", -1)),
          (_ctx.auditWarnings.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.auditWarnings, (warning) => {
                  return (_openBlock(), _createElementBlock("li", { key: warning }, _toDisplayString(warning), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("section", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _cache[41] || (_cache[41] = _createElementVNode("div", null, [
                _createElementVNode("h4", null, "公開監査・成果計測"),
                _createElementVNode("p", null, "AI回答への掲載確率ではなく、技術状態・回答内容・信頼情報・インデックス・観測値を確認します。")
              ], -1)),
              _createElementVNode("button", {
                type: "button",
                class: "secondary",
                disabled: _ctx.outcomesLoading,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.loadOutcomes && _ctx.loadOutcomes(...args)))
              }, _toDisplayString(_ctx.outcomesLoading ? "読み込み中" : _ctx.outcomes ? "最新状態へ更新" : "監査履歴と計測を表示"), 9, _hoisted_9)
            ]),
            (_ctx.outcomes)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  (_ctx.latestAudit)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.auditCategories, (category) => {
                          return (_openBlock(), _createElementBlock("article", {
                            key: category.key,
                            class: _normalizeClass(category.value?.status || 'pending')
                          }, [
                            _createElementVNode("strong", null, _toDisplayString(category.label), 1),
                            _createElementVNode("span", null, _toDisplayString(_ctx.categoryStatusLabel(category.value?.status)), 1),
                            (_ctx.categoryMessages(category.value).length)
                              ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categoryMessages(category.value), (message) => {
                                    return (_openBlock(), _createElementBlock("li", { key: message }, _toDisplayString(message), 1))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ], 2))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.outcomes.latest_decision)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_12, [
                        _cache[42] || (_cache[42] = _createElementVNode("h5", null, "現在の最終判断", -1)),
                        _createElementVNode("strong", null, _toDisplayString(_ctx.outcomeDecisionLabel(_ctx.outcomes.latest_decision.final_decision)), 1),
                        _createElementVNode("ul", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.outcomes.latest_decision.decision_rationale || [], (reason) => {
                            return (_openBlock(), _createElementBlock("li", { key: reason }, _toDisplayString(reason), 1))
                          }), 128))
                        ]),
                        _createElementVNode("small", null, "判断ルール: " + _toDisplayString(_ctx.outcomes.latest_decision.decision_policy_version) + "。遅延・partial・preliminary・異常期間は判断を停止します。", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.outcomes.measurements.length)
                    ? (_openBlock(), _createElementBlock("section", _hoisted_13, [
                        _cache[44] || (_cache[44] = _createElementVNode("h5", null, "時系列計測", -1)),
                        _createElementVNode("table", null, [
                          _cache[43] || (_cache[43] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "期間"),
                              _createElementVNode("th", null, "GSC query cohort"),
                              _createElementVNode("th", null, "GSC URL"),
                              _createElementVNode("th", null, "GA4ランディングページ"),
                              _createElementVNode("th", null, "waaq導線"),
                              _createElementVNode("th", null, "生成AIページ表示"),
                              _createElementVNode("th", null, "判断")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.outcomes.measurements, (item) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: item.id
                              }, [
                                _createElementVNode("td", null, _toDisplayString(_ctx.measurementPeriodLabel(item)), 1),
                                _createElementVNode("td", null, "表示 " + _toDisplayString(item.gsc_query_cohort?.impressions || 0) + " / クリック " + _toDisplayString(item.gsc_query_cohort?.clicks || 0), 1),
                                _createElementVNode("td", null, "表示 " + _toDisplayString(item.gsc_page?.impressions || 0) + " / クリック " + _toDisplayString(item.gsc_page?.clicks || 0), 1),
                                _createElementVNode("td", null, "sessions " + _toDisplayString(item.ga4_landing_page?.sessions || 0) + " / key events " + _toDisplayString(item.ga4_landing_page?.key_events || 0), 1),
                                _createElementVNode("td", null, "CTA " + _toDisplayString(item.waaq_funnel?.article_cta_click || 0) + " / form " + _toDisplayString(item.waaq_funnel?.form_complete || 0) + " / booking " + _toDisplayString(item.waaq_funnel?.booking_confirmed || 0), 1),
                                _createElementVNode("td", null, "impressions " + _toDisplayString(item.generative_ai_page?.impressions || 0) + "（ページ単位）", 1),
                                _createElementVNode("td", null, _toDisplayString(_ctx.outcomeDecisionLabel(item.final_decision)), 1)
                              ]))
                            }), 128))
                          ])
                        ]),
                        _cache[45] || (_cache[45] = _createElementVNode("p", { class: "marketing-publication-note" }, "GA4はランディングページ単位の参考値です。特定queryやAI回答への成果として帰属せず、公開前後差分は相関として扱います。", -1))
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("form", {
                    class: "marketing-search-observation",
                    "data-testid": "marketing-search-observation",
                    onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.saveObservation && _ctx.saveObservation(...args)), ["prevent"]))
                  }, [
                    _cache[63] || (_cache[63] = _createElementVNode("h5", null, "人が確認した検索結果を記録", -1)),
                    _cache[64] || (_cache[64] = _createElementVNode("p", null, "標本観測であり、網羅的な掲載率・AI採用率ではありません。自動検索結果スクレイピングは行いません。", -1)),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("label", null, [
                        _cache[46] || (_cache[46] = _createTextVNode("query", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.observation.query) = $event)),
                          required: "",
                          maxlength: "500"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.observation.query,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[47] || (_cache[47] = _createTextVNode("確認日時", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.observation.observed_at) = $event)),
                          required: "",
                          type: "datetime-local"
                        }, null, 512), [
                          [_vModelText, _ctx.observation.observed_at]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[49] || (_cache[49] = _createTextVNode("engine", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.observation.engine) = $event))
                        }, [...(_cache[48] || (_cache[48] = [
                          _createStaticVNode("<option value=\"google\" data-v-1a70cb3e>Google</option><option value=\"bing\" data-v-1a70cb3e>Bing</option><option value=\"chatgpt\" data-v-1a70cb3e>ChatGPT</option><option value=\"gemini\" data-v-1a70cb3e>Gemini</option><option value=\"perplexity\" data-v-1a70cb3e>Perplexity</option><option value=\"copilot\" data-v-1a70cb3e>Copilot</option><option value=\"other\" data-v-1a70cb3e>その他</option>", 7)
                        ]))], 512), [
                          [_vModelSelect, _ctx.observation.engine]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[50] || (_cache[50] = _createTextVNode("locale", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.observation.locale) = $event)),
                          required: "",
                          maxlength: "8",
                          placeholder: "ja-JP"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.observation.locale,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[51] || (_cache[51] = _createTextVNode("国", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.observation.country) = $event)),
                          required: "",
                          maxlength: "2"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.observation.country,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[52] || (_cache[52] = _createTextVNode("言語", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.observation.language) = $event)),
                          required: "",
                          maxlength: "8"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.observation.language,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[54] || (_cache[54] = _createTextVNode("device", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.observation.device) = $event))
                        }, [...(_cache[53] || (_cache[53] = [
                          _createElementVNode("option", { value: "desktop" }, "desktop", -1),
                          _createElementVNode("option", { value: "mobile" }, "mobile", -1),
                          _createElementVNode("option", { value: "tablet" }, "tablet", -1)
                        ]))], 512), [
                          [_vModelSelect, _ctx.observation.device]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[56] || (_cache[56] = _createTextVNode("検索面", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.observation.search_surface) = $event))
                        }, [...(_cache[55] || (_cache[55] = [
                          _createElementVNode("option", { value: "ai_overview" }, "AI Overview", -1),
                          _createElementVNode("option", { value: "ai_mode" }, "AI Mode", -1),
                          _createElementVNode("option", { value: "organic_search" }, "通常検索", -1)
                        ]))], 512), [
                          [_vModelSelect, _ctx.observation.search_surface]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[58] || (_cache[58] = _createTextVNode("引用", -1)),
                        _withDirectives(_createElementVNode("select", {
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.observation.citation_status) = $event))
                        }, [...(_cache[57] || (_cache[57] = [
                          _createElementVNode("option", { value: "cited" }, "あり", -1),
                          _createElementVNode("option", { value: "not_cited" }, "なし", -1),
                          _createElementVNode("option", { value: "unknown" }, "不明", -1)
                        ]))], 512), [
                          [_vModelSelect, _ctx.observation.citation_status]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[59] || (_cache[59] = _createTextVNode("引用URL", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.observation.citation_url) = $event)),
                          type: "url"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.observation.citation_url,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[60] || (_cache[60] = _createTextVNode("ブラウザ条件", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.observation.observation_conditions.browser_mode) = $event)),
                          maxlength: "80",
                          placeholder: "通常 / シークレット"
                        }, null, 512), [
                          [
                            _vModelText,
                            _ctx.observation.observation_conditions.browser_mode,
                            void 0,
                            { trim: true }
                          ]
                        ])
                      ]),
                      _createElementVNode("label", null, [
                        _cache[61] || (_cache[61] = _createElementVNode("span", null, "ログイン状態", -1)),
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.observation.observation_conditions.signed_in) = $event)),
                          type: "checkbox"
                        }, null, 512), [
                          [_vModelCheckbox, _ctx.observation.observation_conditions.signed_in]
                        ])
                      ])
                    ]),
                    _createElementVNode("label", null, [
                      _cache[62] || (_cache[62] = _createTextVNode("メモ", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.observation.notes) = $event)),
                        maxlength: "2000"
                      }, null, 512), [
                        [
                          _vModelText,
                          _ctx.observation.notes,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("button", {
                      type: "submit",
                      disabled: _ctx.observationSaving
                    }, _toDisplayString(_ctx.observationSaving ? "保存中" : "標本観測を保存"), 9, _hoisted_15)
                  ], 32),
                  (_ctx.outcomes.search_observations.length)
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.outcomes.search_observations, (item) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: item.id
                          }, _toDisplayString(item.observed_at) + " / " + _toDisplayString(item.engine) + " / " + _toDisplayString(item.locale) + " / " + _toDisplayString(_ctx.searchSurfaceLabel(item.search_surface)) + " / " + _toDisplayString(_ctx.citationStatusLabel(item.citation_status)) + " / " + _toDisplayString(item.query), 1))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_ctx.article.wordpress_published_url)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _ctx.article.wordpress_published_url,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "公開記事を確認する", 8, _hoisted_18))
              : _createCommentVNode("", true),
            (_ctx.article.wordpress_edit_url)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: _ctx.article.wordpress_edit_url,
                  target: "_blank",
                  rel: "noopener noreferrer"
                }, "WordPressで編集する", 8, _hoisted_19))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              type: "button",
              class: "secondary",
              disabled: _ctx.submitting || _ctx.article.seo_audit_status == 'pending',
              "data-testid": "marketing-publication-recheck",
              onClick: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.recheckSeo && _ctx.recheckSeo(...args)))
            }, _toDisplayString(_ctx.article.seo_audit_status == "pending" ? "SEO状態を確認中" : "Search Consoleの状態を再確認する"), 9, _hoisted_20),
            _createElementVNode("button", {
              type: "button",
              class: "secondary",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('new')))
            }, "新しい記事を作成する")
          ])
        ]))
      : (_ctx.hasPreflight)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("header", _hoisted_21, [
              _createElementVNode("div", null, [
                _cache[67] || (_cache[67] = _createElementVNode("h4", null, "公開前SEOチェック", -1)),
                (_ctx.strictQualityGate)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_22, "WordPressの現在内容を再取得し、記事品質・根拠・SEO・アクセシビリティの必須ゲートを確認しました。"))
                  : (_openBlock(), _createElementBlock("p", _hoisted_23, "WordPressの現在内容を再取得し、校正後の本文とSEO設定を確認しました。「あとで設定・確認」の項目は公開を止めません。"))
              ]),
              _createElementVNode("button", {
                type: "button",
                class: "secondary",
                disabled: _ctx.reviewDisabled,
                "data-testid": "marketing-publication-review-again",
                onClick: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.reviewPublication && _ctx.reviewPublication(...args)))
              }, "SEO事前確認を再実行", 8, _hoisted_24)
            ]),
            _createElementVNode("dl", _hoisted_25, [
              _cache[68] || (_cache[68] = _createElementVNode("dt", null, "WordPress下書きの状態", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.article.wordpress_remote_snapshot?.status || _ctx.article.wordpress_post_status || "-"), 1),
              _cache[69] || (_cache[69] = _createElementVNode("dt", null, "WordPress最終更新日時", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.article.wordpress_remote_snapshot?.modified_gmt || _ctx.article.wordpress_modified_gmt || "-"), 1),
              _cache[70] || (_cache[70] = _createElementVNode("dt", null, "アプリ最終同期日時", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.article.wordpress_last_synced_at || "-"), 1),
              _cache[71] || (_cache[71] = _createElementVNode("dt", null, "タイトル", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.article.wordpress_remote_snapshot?.title || _ctx.article.sanitized_content?.title || "-"), 1),
              _cache[72] || (_cache[72] = _createElementVNode("dt", null, "SEOタイトル", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.article.seo_title || "-"), 1),
              _cache[73] || (_cache[73] = _createElementVNode("dt", null, "メタディスクリプション", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.article.meta_description || "-"), 1),
              _cache[74] || (_cache[74] = _createElementVNode("dt", null, "slug", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.article.wordpress_remote_snapshot?.slug || _ctx.article.wordpress_slug || "-"), 1),
              _cache[75] || (_cache[75] = _createElementVNode("dt", null, "canonical方針", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.article.canonical_policy || "-"), 1),
              _cache[76] || (_cache[76] = _createElementVNode("dt", null, "robots方針", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.article.index_policy || "-"), 1),
              _cache[77] || (_cache[77] = _createElementVNode("dt", null, "著者ID", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.article.wordpress_remote_snapshot?.author || _ctx.article.wordpress_author_id || "-"), 1),
              _cache[78] || (_cache[78] = _createElementVNode("dt", null, "公開日方針", -1)),
              _cache[79] || (_cache[79] = _createElementVNode("dd", null, "明示承認時に即時公開", -1)),
              _cache[80] || (_cache[80] = _createElementVNode("dt", null, "アイキャッチ画像ID", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.article.wordpress_remote_snapshot?.featured_media || "未設定"), 1),
              _cache[81] || (_cache[81] = _createElementVNode("dt", null, "altテキスト", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.article.sanitized_content?.featured_image_alt_text || "本文画像をチェック済み"), 1),
              _cache[82] || (_cache[82] = _createElementVNode("dt", null, "カテゴリID", -1)),
              _createElementVNode("dd", null, _toDisplayString((_ctx.article.wordpress_remote_snapshot?.categories || _ctx.article.wordpress_category_ids || []).join("、") || "なし"), 1),
              _cache[83] || (_cache[83] = _createElementVNode("dt", null, "タグID", -1)),
              _createElementVNode("dd", null, _toDisplayString((_ctx.article.wordpress_remote_snapshot?.tags || _ctx.article.wordpress_tag_ids || []).join("、") || "なし"), 1),
              _cache[84] || (_cache[84] = _createElementVNode("dt", null, "見出し構造", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.checkLabel("heading_hierarchy")), 1),
              _cache[85] || (_cache[85] = _createElementVNode("dt", null, "内部リンク", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.article.sanitized_content?.internal_link_count || 0) + "件 / " + _toDisplayString(_ctx.checkLabel("internal_links_reachable")), 1),
              _cache[86] || (_cache[86] = _createElementVNode("dt", null, "外部出典", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.article.sanitized_content?.external_source_count || 0) + "件 / " + _toDisplayString(_ctx.checkLabel("external_sources_registered")), 1),
              _cache[87] || (_cache[87] = _createElementVNode("dt", null, "独自情報", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.article.sanitized_content?.first_party_evidence_usage?.length || 0) + "件 / " + _toDisplayString(_ctx.checkLabel("publishable_first_party")), 1),
              _cache[88] || (_cache[88] = _createElementVNode("dt", null, "構造化データ", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.article.schema_plan?.article_type || "BlogPosting") + " / " + _toDisplayString(_ctx.checkLabel("structured_data_output")), 1),
              _cache[89] || (_cache[89] = _createElementVNode("dt", null, "SEOアダプター", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.article.seo_adapter || "core_only"), 1),
              _cache[90] || (_cache[90] = _createElementVNode("dt", null, "公開後の想定URL", -1)),
              _createElementVNode("dd", null, _toDisplayString(_ctx.article.wordpress_link || "WordPress公開応答で確定"), 1)
            ]),
            _createElementVNode("section", _hoisted_26, [
              _createElementVNode("div", null, [
                _cache[91] || (_cache[91] = _createElementVNode("strong", null, "自動確認済み", -1)),
                _createElementVNode("p", null, _toDisplayString(_ctx.automaticItems.join("、") || "なし"), 1)
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("strong", null, _toDisplayString(_ctx.strictQualityGate ? "任意の警告・追加確認" : "あとでWordPressで設定・確認"), 1),
                _createElementVNode("p", null, _toDisplayString(_ctx.manualItems.join("、") || "なし"), 1)
              ])
            ]),
            (_ctx.conflicts.length)
              ? (_openBlock(), _createElementBlock("section", _hoisted_27, [
                  _cache[92] || (_cache[92] = _createElementVNode("h4", null, "WordPress上の手動変更を検出しました", -1)),
                  _createElementVNode("ul", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.conflicts, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: item.field
                      }, _toDisplayString(item.message), 1))
                    }), 128))
                  ]),
                  _cache[93] || (_cache[93] = _createElementVNode("p", null, "WordPressで校正した内容は自動上書きしません。校正内容を採用してSEO事前確認を続けるか、アプリ側で新しい記事を再生成してください。", -1)),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("button", {
                      type: "button",
                      disabled: _ctx.submitting,
                      "data-testid": "marketing-publication-adopt",
                      onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.adoptWordpress && _ctx.adoptWordpress(...args)))
                    }, "WordPressの校正内容を採用して再確認", 8, _hoisted_29),
                    _createElementVNode("button", {
                      type: "button",
                      class: "secondary",
                      onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.$emit('new')))
                    }, "アプリ側で再生成する")
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("section", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.checks, (check) => {
                return (_openBlock(), _createElementBlock("article", {
                  key: check.code,
                  class: _normalizeClass(check.status)
                }, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.statusMark(check.status)), 1),
                  _createElementVNode("div", null, [
                    _createElementVNode("strong", null, _toDisplayString(check.label), 1),
                    (check.message)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_31, _toDisplayString(check.message), 1))
                      : _createCommentVNode("", true)
                  ])
                ], 2))
              }), 128))
            ]),
            (_ctx.canPublish)
              ? (_openBlock(), _createElementBlock("section", _hoisted_32, [
                  (_ctx.manualItems.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_33, _toDisplayString(_ctx.strictQualityGate
                        ? "必須ゲートは合格済みです。上記の任意警告を確認し、人として最終承認してください。"
                        : "上記の項目は未設定のままWordPressへ公開できます。公開後も「WordPressで編集する」から追加・変更できます。"), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("label", null, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.confirmed) = $event)),
                      type: "checkbox"
                    }, null, 512), [
                      [_vModelCheckbox, _ctx.confirmed]
                    ]),
                    (_ctx.strictQualityGate)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_34, [...(_cache[94] || (_cache[94] = [
                          _createTextVNode("記事品質、根拠、反論・制約、CTA、技術要件を確認し、人としてこの記事を最終承認してWordPress上で公開します。", -1),
                          _createElementVNode("br", null, null, -1),
                          _createTextVNode("公開後は一般のユーザーと検索エンジンから閲覧可能になります。", -1)
                        ]))]))
                      : (_openBlock(), _createElementBlock("span", _hoisted_35, [...(_cache[95] || (_cache[95] = [
                          _createTextVNode("あとで設定・確認する項目があることを確認し、この記事をWordPress上で公開します。", -1),
                          _createElementVNode("br", null, null, -1),
                          _createTextVNode("公開後は一般のユーザーと検索エンジンから閲覧可能になります。", -1)
                        ]))]))
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    disabled: !_ctx.confirmed || _ctx.submitting,
                    "data-testid": "marketing-publication-publish",
                    onClick: _cache[23] || (_cache[23] = 
//@ts-ignore
(...args) => (_ctx.publishArticle && _ctx.publishArticle(...args)))
                  }, _toDisplayString(_ctx.submitting ? "公開処理を受け付け中" : (_ctx.strictQualityGate ? "品質ゲートを承認してWordPressへ公開" : (_ctx.manualItems.length ? "このままWordPressへ公開" : "WordPressへ公開"))), 9, _hoisted_36)
                ]))
              : (_ctx.article.publication_status == 'publishing')
                ? (_openBlock(), _createElementBlock("p", _hoisted_37, "WordPressへ公開中です。ボタンの重複操作は停止しています。"))
                : (_openBlock(), _createElementBlock("p", _hoisted_38, "警告または競合を解消し、公開前チェックを再実行してください。"))
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_39, [
            _cache[96] || (_cache[96] = _createElementVNode("p", null, "WordPressでの校正後に、手動変更とSEO準備状況を確認します。この操作だけでは公開されません。", -1)),
            _createElementVNode("button", {
              type: "button",
              disabled: _ctx.reviewDisabled,
              "data-testid": "marketing-publication-review",
              onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.reviewPublication && _ctx.reviewPublication(...args)))
            }, _toDisplayString(_ctx.submitting ? "チェック中" : "校正後、SEO事前確認へ進む"), 9, _hoisted_40)
          ]))
  ]))
}